// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      orderSourceOptions: [
        "Local",
        "State",
        "National",
        "Overseas"
      ],
      // eslint-disable-next-line
      orderTransationOptions: [
        "Warehouse",
        "Internal",
        "External"
      ],
      // eslint-disable-next-line
      orderTransportOptions: [
        "Local",
        "Truck",
        "Train",
        "Ship",
        "Plan"
      ],
      // eslint-disable-next-line
      orderMobilisationOptions: [
        "Own",
        "State",
        "Country",
        "Overseas"
      ],
      // eslint-disable-next-line
      orderMobilisationStatusOptions: [
        "Pending",
        "Confirmed",
        "Issue"
      ],
      // eslint-disable-next-line
      orderPaymentMethodOptions: [
        "Cash",
        "Direct",
        "Card",
        "PO",
        "Transfer",
        "Crypto"
      ],
      // eslint-disable-next-line
      orderQualityAssurancetOptions: [
        "NR",
        "Inspector",
        "Certificate"
      ],
      // eslint-disable-next-line
      orderPaymentStatusOptions: [
        "Pending",
        "Deposit",
        "Paid"
      ],
      // eslint-disable-next-line
      orderThemeOptions: [
        "IT1",
        "IT2",
        "MV1",
        "MV2",
        "PV1",
        "PV2",
        "VR1",
        "VR2",
        "WR1",
        "WV1",
        "WV2"
      ]
    };
  }
};
